import { GQL } from '../graphQl'

export const getCheckList = () => GQL`query getCheckList($conditions:core_form_templates_bool_exp, $perPage: Int , $skip: Int, $orderBy: [core_form_templates_order_by!]) {
  core_form_templates(where: $conditions, limit: $perPage, offset: $skip, order_by: $orderBy) {
    name
    id
    form_type
    sequence_template_id
    workflow_template_id
    workflow_template {
      name
      id
    }
    core_form_type {
      name
    }
    template_versions {
      active
      version_id
    }
    created_on
    created_by
    template_created_by {
      first_name
      last_name
    }
  }
  core_form_templates_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
}`

export const getCheckListByIdQuery = () => GQL`query getCheckListByIdQuery ($id: uuid!){
core_form_templates_by_pk(id: $id) {
    name
    id
    description
    core_form_type {
      name
      id
    }
    template_versions {
      active
      version_id
      id
      template_fields {
        autogenerated
        caption
        custom_list_id
        field_id
        field_name
        field_type_id
        fixed
        required
        visibility
        table_data
        template_version_id
        form_field {
          key
        }
      }
    }
  }
}`
